const mobmenu = () => {
  document.addEventListener('click', (e) => {
    const parentLink = e.target.closest('.parent>a:not(.mainmenu a)');
    if (!parentLink) return;
    e.preventDefault();
    const linkLi = parentLink.closest('li');
    const listUl = linkLi.querySelector('ul');
    if (linkLi.classList.contains('is-open')) {
      listUl.style.height = '';
      parentLink.closest('li').classList.remove('is-open');
      return;
    }
    listUl.style.height = `${listUl.scrollHeight}px`;
    parentLink.closest('li').classList.add('is-open');
  });
  window.isSideMenuAccordeonStarted = true;
};
export default mobmenu;
